module.exports = __webpack_public_path__ + "static/media/cloud-hail-mixed.25e0cb99.svg";